module.exports = __webpack_public_path__ + "img/101.5fbc2630.png";